import React, { Component } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

import { translate } from "react-multi-lang";
import {
    resolveMediaUrl,
    handleMediaImgError,
} from "../../Helper/mediaUrl";

class VideoTrailer extends Component {
    state = {};

    render() {
        const { t } = this.props;
        const trailerDetails = this.props.trailer || [];

        const playableTrailers = trailerDetails.filter(
            (trailer) =>
                trailer &&
                trailer.resolutions &&
                trailer.resolutions.original
        );

        if (!playableTrailers.length) {
            return null;
        }

        let slidesToShowCount = 1;

        if (playableTrailers.length > 3) {
            slidesToShowCount = 4;
        } else {
            slidesToShowCount = playableTrailers.length;
        }
        var trailerSlider = {
            dots: false,
            arrow: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false
        };

        return (
            <div className="slider-topbottom-spacing pl-0 pr-0 slider-overlay">
                <div className="pr-4per pl-4per">
                    <h1 className="banner_video_title">
                        {t("trailer_and_more")}
                    </h1>
                </div>
                <div>
                    <Slider
                        {...trailerSlider}
                        className="more-like-slider slider"
                    >
                        {playableTrailers.map((trailer, index) => (
                            <div key={trailer.name || index}>
                                <div className="relative">
                                    <img
                                        className="trailers-img placeholder"
                                        alt="episode-img"
                                        src={resolveMediaUrl(trailer.default_image)}
                                        data-src="/assets/img/placeholder.gif"
                                        onError={handleMediaImgError}
                                    />
                                    <div className="trailers-img-overlay">
                                        <Link
                                            to={{
                                                pathname: `/video/${trailer.name}`,
                                                state: {
                                                    videoDetailsFirst: trailer,
                                                    videoFrom: "trailer"
                                                }
                                            }}
                                        >
                                            <div className="thumbslider-outline">
                                                <i className="fas fa-play" />
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="episode-content">
                                    <h4 className="episode-content-head">
                                        {trailer.name}
                                    </h4>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        );
    }
}

export default translate(VideoTrailer);
